import { createRoutine } from 'redux-saga-routines';

export const generateAnswerSheets = createRoutine('GENERATE_ANSWER_SHEET');
export const generateAnswerSheetsPreview = createRoutine(
  'GENERATE_ANSWER_SHEET_PREVIEW',
);
export const resetAnswerSheetsPreview = createRoutine('RESET_ANSWER_SHEET_URL');
export const downloadAllAnswerSheets = createRoutine(
  'DOWNLOAD_ALL_ANSWER_SHEETS',
);
export const downloadIndividualAnswerSheet = createRoutine(
  'DOWNLOAD_INDIVIDUAL_ANSWER_SHEET',
);
export const initiateDownloadForUser = createRoutine(
  'INITIATE_DOWNLOAD_ANSWER_SHEET_FOR_USER',
);
export const downloadGeneratedAnswerSheet = createRoutine(
  'DOWNLOAD_GENERATED_ANSWER_SHEET',
);
